export const PERMISSIONS = {
  OWNER: 'owner',
  CONTRIBUTOR: 'contributor',
  VIEW_ONLY: 'reader',
  COPIER: 'copier',
}

export const PERMISSION_ACTIONS = {
  SHARE: 'share',
  ADD_ENTITY: 'collection.add_entity',
  UPDATE: 'collection.update',
  DELETE: 'collection.delete',
  READ: 'collection.get',
}
